import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ChevronUpIcon, FacebookIcon, InstagramIcon, MailIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://wood-therapy-pro-megapack.impultienda.ar/checkout';
const faqs = [['Does it work if I am a beginner in wood therapy?', 'Yes. Volume 1 starts from the fundamentals: anatomy, tools and the base protocol. You do not need prior experience to understand and apply the material.'], ['How do I receive the material?', 'Instant PDF download as soon as your purchase is confirmed. Open it on desktop, tablet or phone, and print anything you need.'], ['Does it work if I already do massage or work in aesthetics?', 'Especially. The MegaPack is designed for any wellness professional who wants to add or improve wood therapy as a differentiating service.'], ['Is it a course with video lessons?', 'No. It is ready-to-use material in PDF format. No long videos and no platforms: open the volume, pick the protocol and apply it.'], ['Can I use the forms and templates with my clients?', 'Yes. The forms, consent sheets and handout material are designed to be used directly with your clients. You can personalize them with your name or logo.'], ['Does it work if I want to start selling sessions from scratch?', 'Yes. The 21-Day Agenda and the WhatsApp and Instagram scripts help you go from zero to a service that is organized and communicated.'], ['What if it is not for me?', 'You have a 7-day guarantee with a full refund, no questions asked.']];
const costRows = [['Searching for protocols before every session', '2+ unpaid working hours every week'], ['Not having a clear service menu', 'You charge less than your work is worth'], ['A client who cannot see documented results', 'Drops off after 2 sessions — you lose $40–150 per client'], ['Sessions with no defined structure', 'Your professional image at stake with every improvisation'], ['Not knowing how to offer packages', 'You keep charging per single session with no way to scale'], ['Tools with no clear protocol', 'You always use the same two and leave the kit unused']];
const testimonials = [{
  quote: 'Volume 2 is gold. Within 2 minutes I had the exact protocol with tool order and timing.',
  name: 'Rachel Owens',
  role: 'Certified wood therapist, Denver, CO',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d254086f-3083-40d6-99ea-92fad4ca7ad5.jpg'
}, {
  quote: 'I sold my first 8-session package for $280 using the program template.',
  name: 'Emily Tan',
  role: 'Body therapist, Sydney, Australia',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/143cc77f-0bfb-497c-8da9-39bf8a5edb8f.jpg'
}, {
  quote: 'The WhatsApp scripts mean answering the price question no longer gives me anxiety.',
  name: 'Hannah Clarke',
  role: 'Wellness entrepreneur, Dublin, Ireland',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e64e56c0-e711-4024-97e0-37413b78e340.jpg'
}, {
  quote: 'The client form bonus gave my service the image of a professional clinic.',
  name: 'Jasmine Patel',
  role: 'Pilates instructor, London, UK',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4f8a4766-6792-4151-ae7f-e87d1d0e60e0.jpg'
}, {
  quote: 'The postpartum protocol let me charge double what a standard contouring session brings in.',
  name: 'Chloe Bennett',
  role: 'Manual therapist, Auckland, New Zealand',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/36866034-7d6e-44ce-a253-3e45def9b167.jpg'
}, {
  quote: 'I used to improvise every session. Now I work with my timeline in front of me and far more confidence.',
  name: 'Danielle Brooks',
  role: 'Wellness massage therapist, Atlanta, GA',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8b065f46-b8e4-47ad-b9e9-002a9698737b.jpg'
}];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  return <div className="w-full bg-cream" data-id="element-114" data-mp="23g2qvbargibl">
      <section className="bg-brand-900 px-4 py-11 text-center text-white sm:px-6" data-id="element-115" data-mp="27fjwq5u3nhha">
        <p className="text-xs font-black tracking-[0.12em] text-accent" data-id="element-116" data-mp="2cffqzdczvujn">
          LAUNCH PRICE — CLOSES IN:
        </p>
        <p aria-live="polite" className="mt-3 font-mono text-4xl font-black tracking-tight text-white sm:text-6xl" data-id="element-117" data-mp="2hcy3fdq80rwe">
          {clock}
        </p>
        <p className="mt-3 text-sm text-gray-300" data-id="element-118" data-mp="2r42e418v5qlf">
          After that it goes back up to $97. It does not come back.
        </p>
        <div className="mx-auto mt-5 h-2 max-w-md overflow-hidden rounded-full bg-brand-800" data-id="element-119" data-mp="2v448dpc9rhqo">
          <div className="h-full w-[84%] rounded-full bg-accent" data-id="element-120" data-mp="305jtfheg5o92" />
        </div>
        <p className="mt-2 text-xs text-brand-100" data-id="element-121" data-mp="353269ivl4nmc">
          84% of the launch-price spots are already taken
        </p>
      </section>

      <section id="pricing" className="mx-auto max-w-6xl scroll-mt-4 px-4 py-12 sm:px-6 md:py-20" data-id="element-122" data-mp="151vihpv11zcz">
        <div className="text-center" data-id="element-123" data-mp="100el44br4v15">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-124" data-mp="1erf4h4e1e9c2">
            Get your MegaPack
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-125" data-mp="19yue6cucaeda">
            Everything you need to work with a system
          </h2>
        </div>
        <div className="mx-auto mt-9 max-w-2xl" data-id="element-126" data-mp="1jqrrpq8tlif6">
          <article className="flex flex-col rounded-2xl border border-brand-100 bg-white p-6 text-center shadow-sm md:p-8" data-id="element-127" data-mp="1jpyt5ck0lz84">
            <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-128" data-mp="1sqwypza3qest">
              WOOD THERAPY PRO MEGAPACK
            </p>
            <h3 className="mt-2 text-2xl font-black text-brand-900" data-id="element-129" data-mp="3b7150qs6tzc">
              WOOD THERAPY PRO MEGAPACK
            </h3>
            <p className="mt-2 text-sm text-gray-600" data-id="element-130" data-mp="3ujum3fl40f6d">
              6 Volumes + 5 Bonuses — Every protocol solved for you.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-gray-700" data-id="element-131" data-mp="2ezc2n36i3fjf">
              {['6 complete volumes with 300+ pages', '5 strategic bonuses included', 'Printable protocols, forms and checklists'].map(item => <li key={item} className="flex gap-2" style={{
              textAlign: "left"
            }} data-id="element-132" data-mp="257fwr5y6al4n">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-133" data-mp="1r8g65sr3nw5u" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-134" data-mp="1hcd5krbwc5l0">
              <p data-id="element-135" data-mp="1hdeh0wwtqu39">
                <span className="mr-2 text-lg text-gray-400 line-through" data-id="element-136" data-mp="1hdxykcikbggr">
                  $97
                </span>
                <strong className="font-black text-brand-900 text-[48px]" data-id="element-137" data-mp="3bpujdmmi1o2u">
                  $27
                </strong>{' '}
                <span className="font-bold text-brand-600" data-id="element-138" data-mp="3gnmltakrssla">USD</span>
              </p>
              <p className="mt-1 text-xs text-gray-500" data-id="element-139" data-mp="24fu9rpf72t3r">
                The product will be charged in your local currency.
              </p>
            </div>
            <a href={CHECKOUT_URL} className="mt-4 block rounded-xl border-2 border-brand-600 px-4 py-3.5 text-center text-sm font-extrabold text-brand-700 transition-colors hover:bg-brand-50" data-id="element-140" data-mp="1zic4qa4asy11">
              I WANT MY MEGAPACK
            </a>
          </article>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-141" data-mp="1gp8bgpuzsn6y">
        <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-142" data-mp="1gs45w47mstqn">
          More professionals, more confidence
        </h2>
        <div className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-143" data-mp="16sddc82msot7">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex flex-col rounded-xl border border-brand-100 bg-white p-5" data-id="element-144" data-mp="363d4r7275apd">
              <div className="flex gap-0.5 text-accent" aria-label="5 out of 5 stars" data-id="element-145" data-mp="38pdramem0h6u">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-146" data-mp="3iexc3xlvul4c" />)}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-gray-700" data-id="element-147" data-mp="2pqhzfhq84ew6">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto flex items-center gap-3 pt-4" data-id="element-148" data-mp="2uq4gk296afa9">
                <img src={testimonial.image} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full border border-brand-100 object-cover" data-id="element-149" data-mp="2zo66n750nev8" />
                <div className="min-w-0" data-id="element-150" data-mp="exf6zxxhvs7m">
                  <p className="text-sm font-bold text-brand-900" data-id="element-151" data-mp="f0jkjlwuo0ay">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-152" data-mp="350vmd0fxpuo6">{testimonial.role}</p>
                </div>
              </footer>
            </article>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6" data-id="element-153" data-mp="3dsxmsyq07ayg">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-brand-100 bg-white p-7 text-center shadow-sm md:p-10" data-id="element-154" data-mp="3dtfrmjqqexhz">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand-600" data-id="element-155" data-mp="3itlfrpxsm1vb" />
          <h2 className="mt-4 text-3xl font-black text-brand-900" data-id="element-156" data-mp="2m3axvuh30y43">
            7-DAY GUARANTEE — NO QUESTIONS ASKED
          </h2>
          <p className="mt-4 leading-relaxed text-gray-600" data-id="element-157" data-mp="2v266fd7lmkak">
            Open the volumes. Use them in real sessions. If within 7 days it is
            not what you expected, we refund 100%, with no forms and no
            complications.
          </p>
          <p className="mt-5 text-sm font-bold text-brand-600" data-id="element-158" data-mp="abfgivpvqc05">
            Refund rate: under 1%.
          </p>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-159" data-mp="1zt2v3xgbahg1">
        <div className="mx-auto max-w-3xl" data-id="element-160" data-mp="1zsb0aoujgnqt">
          <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-161" data-mp="1uu9jkakl50ii">
            Frequently asked questions
          </h2>
          <div className="mt-8 space-y-3" data-id="element-162" data-mp="1q27zi2h6e5hx">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-gray-200" data-id="element-163" data-mp="1h34dapmpp9z7" data-mpi={index}>
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-5 py-4 text-left text-sm font-bold text-brand-900" data-id="element-164" data-mp="1c26y8lx00w1x">
                    {question}
                    {isOpen ? <ChevronUpIcon className="h-5 w-5 shrink-0" data-id="element-165" data-mp="2wk4rts2eh4au" /> : <ChevronDownIcon className="h-5 w-5 shrink-0" data-id="element-166" data-mp="usuwmup73nfl" />}
                  </button>
                  {isOpen && <div className="bg-white px-5 py-4 text-sm leading-relaxed text-gray-600" data-id="element-167" data-mp="kwi4w2d7njnh">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-168" data-mp="1diknj6pu7p28">
        <div className="mx-auto max-w-6xl text-center" data-id="element-169" data-mp="1ij8i22d9yo17">
          <h2 className="text-3xl font-black md:text-4xl" data-id="element-170" data-mp="14kiimg2zgc9o">
            What does it cost to keep improvising?
          </h2>
          <p className="mt-4 text-brand-100" data-id="element-171" data-mp="18k9f90f6xmm4">
            Your next client could experience something completely different.
          </p>
          <div className="mt-8 overflow-x-auto rounded-xl border border-brand-700 text-left" data-id="element-172" data-mp="3pckmtrbrxapg">
            <table className="min-w-[650px] w-full text-sm" data-id="element-173" data-mp="3t9p2jlf7at70">
              <thead data-id="element-174" data-mp="3lqzbha09bkwi">
                <tr className="bg-brand-800" data-id="element-175" data-mp="3lqftxueiqyj0">
                  <th className="p-4" data-id="element-176" data-mp="3gtpcp3qz9ww0">Without the MegaPack</th>
                  <th className="p-4" data-id="element-177" data-mp="3gva7muh7fhue">Real cost</th>
                </tr>
              </thead>
              <tbody data-id="element-178" data-mp="3vodrx9m6k9ot">
                {costRows.map(([without, cost]) => <tr key={without} className="border-t border-brand-700" data-id="element-179" data-mp="3qsolcmbqtsj0">
                    <td className="p-4 text-brand-100" data-id="element-180" data-mp="330zt15yx9422">{without}</td>
                    <td className="p-4 font-semibold text-white" data-id="element-181" data-mp="2y2px2t5dhzfe">{cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-10 font-serif text-2xl italic text-accent" data-id="element-182" data-mp="3csx6kjdek83y">
            “Your next session can be the most professional one you have ever
            given.”
          </p>
          <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-white p-7 text-brand-900 md:p-10" data-id="element-183" data-mp="2k9qfmlm15v57">
            <h3 className="text-3xl font-black" data-id="element-184" data-mp="2fbowk0oltvtq">
              Stop improvising. Start working with a system.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-gray-600" data-id="element-185" data-mp="1ij0a5wsq3p37">
              Join wellness professionals who already run sessions with a clear
              protocol, clients who come back and a service that feels premium.
            </p>
            <div className="mt-6 grid gap-3 border-y border-brand-100 py-5 text-left text-sm sm:grid-cols-2" data-id="element-186" data-mp="1wd9r8xykh9m5">
              {['Your 300 pages of protocols available', 'A proven method, area by area', 'Programs with documented follow-up', 'Closed packages and programs', 'Every tool with its exact function', 'A professional image from first contact'].map(item => <span key={item} className="flex gap-2 font-semibold" data-id="element-187" data-mp="fyhvqc64jm8m">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-188" data-mp="g0ck60gltwhg" />
                  {item}
                </span>)}
            </div>
            <p className="mt-6 text-xs font-bold tracking-wider text-brand-600" data-id="element-189" data-mp="df4sanpvlp1r">
              THE PRICE CLOSES IN: {clock}
            </p>
            <p className="mt-2 font-bold text-[40px]" data-id="element-190" data-mp="3nqlrvziboz4">$27 USD</p>
            <a href={CHECKOUT_URL} className="mt-6 block rounded-xl bg-brand-600 px-5 py-4 text-sm font-extrabold text-white transition-colors hover:bg-brand-700" data-id="element-191" data-mp="3oa2j9df87bk">
              YES, I WANT MY WOOD THERAPY PRO MEGAPACK
            </a>
            <p className="mt-4 text-xs text-gray-500" data-id="element-192" data-mp="recw5twzhlca">
              100% secure payment · Instant access · 7-day guarantee
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-[#102015] px-4 py-10 text-center text-sm text-gray-400 sm:px-6" data-id="element-193" data-mp="id6e3geos2gx">
        <div className="mx-auto max-w-4xl" data-id="element-194" data-mp="374z38eqbomtb">
          <p className="font-bold text-white" data-id="element-195" data-mp="375scbmcr7oem">WOOD THERAPY PRO MEGAPACK™</p>
          <p className="mx-auto mt-3 max-w-xl leading-relaxed" data-id="element-196" data-mp="331swl5zastmb">
            The most complete system of ready-to-use protocols for wood therapy
            professionals. Because working on your clients' bodies should not
            start with doubts the night before.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-197" data-mp="2ummyjsrn1w9h">
            <a href="mailto:tuproximonivel216@gmail.com" className="flex items-center gap-2 hover:text-white" data-id="element-198" data-mp="2zkofo85i7lib">
              <MailIcon className="h-4 w-4" data-id="element-199" data-mp="2lryw0adg6sod" />
              tuproximonivel216@gmail.com
            </a>
            <a href="https://www.instagram.com/tuproximonivel216/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-200" data-mp="2qlkwl46c763t">
              <InstagramIcon className="h-4 w-4" data-id="element-201" data-mp="2gs401setfcwg" />
              Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=61555374626740" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-202" data-mp="22ws6vpgb5uhn">
              <FacebookIcon className="h-4 w-4" data-id="element-203" data-mp="1j9f8ygvhzy70" />
              Facebook
            </a>
          </div>
        </div>
      </footer>
    </div>;
}